<template>
  <Transition name="modal">
    <div v-if="isOpen" class="fixed inset-0 z-[1000] flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-navy-900/40 backdrop-blur-sm" @click="handleResult('cancel')"></div>
      
      <div class="relative bg-white dark:bg-navy-800 rounded-2xl shadow-xl w-full max-w-md p-6 transform transition-all">
        <div class="flex items-center gap-4 mb-4">
          <div class="w-10 h-10 shrink-0 rounded-full flex items-center justify-center"
               :class="{
                 'bg-red-50 text-red-500 dark:bg-red-500/10 dark:text-red-400': options.type === 'danger',
                 'bg-amber-50 text-amber-500 dark:bg-amber-500/10 dark:text-amber-400': options.type === 'warning',
                 'bg-blue-50 text-blue-brand dark:bg-blue-500/10 dark:text-blue-400': options.type === 'info' || !options.type
               }">
            <!-- Danger Icon -->
            <svg v-if="options.type === 'danger'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>
            <!-- Warning Icon -->
            <svg v-else-if="options.type === 'warning'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            <!-- Info Icon -->
            <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          </div>
          <div>
            <h3 class="text-lg font-bold text-gray-900 dark:text-white">{{ options.title }}</h3>
          </div>
        </div>
        
        <p class="text-[14px] text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          {{ options.message }}
        </p>

        <div class="flex items-center justify-end gap-2.5">
          <button @click="handleResult('cancel')" class="px-4 py-2 text-[13px] font-semibold text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-navy-900 hover:bg-gray-200 dark:hover:bg-navy-900/80 rounded-xl transition-colors">
            {{ options.cancelText || 'Bekor qilish' }}
          </button>
          
          <button v-if="options.discardText" @click="handleResult('discard')" class="px-4 py-2 text-[13px] font-semibold text-red-500 bg-red-50 hover:bg-red-100 dark:bg-red-500/10 dark:hover:bg-red-500/20 rounded-xl transition-colors">
            {{ options.discardText }}
          </button>

          <button @click="handleResult('confirm')" class="px-4 py-2 text-[13px] font-semibold text-white rounded-xl transition-colors shadow-sm"
                  :class="{
                    'bg-red-500 hover:bg-red-600': options.type === 'danger',
                    'bg-amber-500 hover:bg-amber-600': options.type === 'warning',
                    'bg-blue-brand hover:bg-blue-600': options.type === 'info' || !options.type
                  }">
            {{ options.confirmText || 'Tasdiqlash' }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm'

const { isOpen, options, handleResult } = useConfirm()
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
.modal-enter-active .relative,
.modal-leave-active .relative {
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.2s ease;
}
.modal-enter-from .relative {
  opacity: 0;
  transform: scale(0.95) translateY(10px);
}
.modal-leave-to .relative {
  opacity: 0;
  transform: scale(0.95) translateY(10px);
}
</style>
